import type {
  CandidateStatus,
  InterviewOutcome,
  OfferStatus,
  OpeningStatus,
} from './constants';

export interface JobOpening {
  id: number;
  public_id: string;
  title: string;
  department: string;
  description: string;
  /** Where the role is published externally (job board, careers page). */
  external_url: string;
  status: OpeningStatus;
  openings_count: number;
  created: string;
  modified: string;
}

export interface JobOpeningInput {
  title: string;
  department: string;
  description: string;
  external_url: string;
  status: OpeningStatus;
  openings_count: number;
}

export interface Candidate {
  id: number;
  public_id: string;
  job_opening: number | null;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  telegram: string;
  whatsapp: string;
  status: CandidateStatus;
  source: string;
  notes: string;
  owner: number | null;
  created: string;
  modified: string;
}

export interface CandidateInput {
  job_opening: number | null;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  telegram: string;
  whatsapp: string;
  status: CandidateStatus;
  source: string;
  notes: string;
  owner: number | null;
}

/** One scorecard line: a criterion rated 1–5. */
export interface CriteriaRating {
  criterion: string;
  score: number;
}

export interface Interview {
  id: number;
  public_id: string;
  candidate: number;
  stage_name: string;
  scheduled_at: string | null;
  interviewer: number | null;
  outcome: InterviewOutcome;
  notes: string;
  criteria_ratings: CriteriaRating[];
  created: string;
  modified: string;
}

export interface InterviewInput {
  candidate: number;
  stage_name: string;
  scheduled_at: string | null;
  interviewer: number | null;
  outcome: InterviewOutcome;
  notes: string;
  criteria_ratings: CriteriaRating[];
}

/** Offer — amount/currency may be masked server-side for non-money roles (C7). */
export interface Offer {
  id: number;
  public_id: string;
  candidate: number;
  job_opening: number | null;
  amount: string | null;
  currency: string | null;
  status: OfferStatus;
  description: string;
  sent_at: string | null;
  responded_at: string | null;
  created: string;
  modified: string;
}

export interface OfferInput {
  candidate: number;
  job_opening: number | null;
  amount: string | null;
  currency: string;
  status: OfferStatus;
  description: string;
  sent_at: string | null;
  responded_at: string | null;
}

export function candidateName(c: Candidate): string {
  const full = `${c.first_name} ${c.last_name}`.trim();
  return full || c.email || `Candidate #${c.id}`;
}
